export const newLine = '\n';
export const reNewLines = /\\n/g;
export const allNewLines = /\r\n|\n|\r/;
export const keyVal = /^\s*([\w.-]+)\s*=\s*(.*)?\s*$/;
export const stripQuotes = /^['"]{1}(.*?)['"]{1}$/;
